export const PYTHON_ENVIRONMENTS_COLUMN = {
  VERSION: 'version',
  CREATED_AT: 'createdAt',
  CREATED_BY: 'createdBy',
  STATUS: 'status',
  LOGS: 'buildLogs'
};
